import {Component, EventEmitter, HostListener, Input, Output, TemplateRef, ViewChild, ViewChildren,} from '@angular/core';
import {Columns, Config} from '../..';
import {StyleService} from '../../services/style.service';

@Component({
  selector: '[table-thead]',
  templateUrl: './thead.component.html',
  // changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [StyleService],
  standalone: false
})
export class TableTHeadComponent {
  public menuActive = false;
  public openedHeaderActionTemplate: string | null = null;
  public onSelectAllBinded = this.onSelectAll.bind(this);

  @Input() config: Config;
  @Input() columns: Columns[];
  @Input() sortKey;
  @Input() sortState;
  @Input() selectAllTemplate;
  @Input() filtersTemplate;
  @Input() isAllSelected: boolean;
  @Input() additionalActionsTemplate: TemplateRef<void>;
  @Output() readonly filter = new EventEmitter<Array<{ key: string; value: string }>>();
  @Output() readonly order = new EventEmitter<Columns>();
  @Output() readonly selectAll = new EventEmitter<void>();
  @Output() readonly event = new EventEmitter<{ event: string; value: any; data?: any }>();
  @ViewChildren('headerDropdown') headerDropdown;
  @ViewChild('additionalActionMenu') additionalActionMenu;

  constructor(public readonly styleService: StyleService) {
  }

  @HostListener('document:click', ['$event.target'])
  public onClick(targetElement: any): void {
    if (
      this.additionalActionMenu &&
      !this.additionalActionMenu.nativeElement.contains(targetElement)
    ) {
      this.menuActive = false;
    }

    // if click outside the header then close opened Header Action Template
    if (
      this.openedHeaderActionTemplate &&
      // if no header have the clicked point
      !this.headerDropdown.toArray().some((ref) => ref.nativeElement.contains(targetElement))
    ) {
      this.openedHeaderActionTemplate = null;
    }
  }

  getColumnDefinition(column: Columns): boolean {
    return column.searchEnabled;
  }

  orderBy(column: Columns): void {
    if (this.isOrderEnabled(column)) {
      this.order.emit(column);
    }
  }

  isOrderEnabled(column: Columns): boolean {
    const columnOrderEnabled = column.orderEnabled === undefined ? column.searchEnabled : !!column.orderEnabled;
    return this.config.orderEnabled && columnOrderEnabled;
  }

  onSearch($event: { key: string; value: string }): void {
    this.filter.emit([$event]);
  }

  getColumnWidth(column: any): string | null {
    if (column.width) {
      return column.width;
    }
    return this.config.fixedColumnWidth ? 100 / this.columns.length + '%' : null;
  }

  onSelectAll(): void {
    this.selectAll.emit();
  }

  showHeaderActionTemplateMenu(column: Columns): void {
    if (!column.headerActionTemplate) {
      console.error('Column [headerActionTemplate] property not defined');
    }
    if (this.openedHeaderActionTemplate === column.key) {
      this.openedHeaderActionTemplate = null;
      return;
    }
    this.openedHeaderActionTemplate = column.key;
  }

  showMenu(): void {
    if (!this.additionalActionsTemplate) {
      console.error('[additionalActionsTemplate] property not defined');
    }
    this.menuActive = !this.menuActive;
  }

}
